module.exports = __webpack_public_path__ + "static/media/flowerInTheNight.57341e7d.jpg";